import React, { useState } from "react";
import DoubleRangeSlider from "../../Shared/DoubleRangeSlider";
import MultiSelect from "../../Shared/MultiSelect";

const MobileFilterMenu = (props) => {
  const [RangesAreDisplayed, setRangesAreDisplayed] = useState(true);
  const [LikesChanged, setLikesChanged] = useState(false);
  const [BookmarksChanged, setBookmarksChanged] = useState(false);
  const [ApplicationsChanged, setApplicationsChanged] = useState(false);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const addActiveFilter = (Id) => {
    if (document.getElementById(Id) === null) {
      let NewValue = props.ActiveFilterCount + 1;
      props.SetActiveFilterCount(NewValue);
    }
  };
  const removeActiveFilter = () => {
    let NewValue = props.ActiveFilterCount - 1;
    props.SetActiveFilterCount(NewValue);
  };

  const addRangeActiveFilter = (Id) => {
    if (Id === "Like") {
      if (!LikesChanged) {
        setLikesChanged(true);
        let NewValue = props.ActiveFilterCount + 1;
        props.SetActiveFilterCount(NewValue);
      }
    } else if (Id === "Bookmark") {
      if (!BookmarksChanged) {
        setBookmarksChanged(true);
        let NewValue = props.ActiveFilterCount + 1;
        props.SetActiveFilterCount(NewValue);
      }
    } else if (Id === "App") {
      if (!ApplicationsChanged) {
        setApplicationsChanged(true);
        let NewValue = props.ActiveFilterCount + 1;
        props.SetActiveFilterCount(NewValue);
      }
    }
  };
  const handleClear = () => {
    if (document.getElementById("city-clear")) {
      document.getElementById("city-clear").click();
    }
    if (document.getElementById("language-clear")) {
      document.getElementById("language-clear").click();
    }
    setRangesAreDisplayed(false);
    setTimeout(() => {
      setRangesAreDisplayed(true);
    }, 10);

    props.SetActiveFilterCount(0);

    setLikesChanged(false);
    setBookmarksChanged(false);
    setApplicationsChanged(false);
  };

  const Close = () => {
    props.GetSingleBarChartData();
    props.Close();
  };

  const apply = () => {
    props.GetSingleBarChartData();
    props.Close();
  };

  return (
    <div
      className={props.MobileFilterIsOpen ? "mobile-filter-wrapper" : "hidden"}
    >
      <section className="filters-head">
        <i className="feather-x" onClick={() => Close()}></i>
        <h1>{translateText("filters")}</h1>
        <span onClick={() => handleClear()}>{translateText("clear")}</span>
      </section>
      <main className="filters-body">
        <section className="filters-wrapper">
          <section className="select-filters">
            <div className="dropdown-holder">
              <p className="dropdown-label">{translateText("location")}</p>
              <MultiSelect
                Initial={translateText("all_cities")}
                Options={props.AllLocations}
                IsWithId
                Id={"city"}
                PreSelectedId=""
                ChangeHandler={() => addActiveFilter("city-clear")}
                OnReset={() => removeActiveFilter()}
              />
            </div>
            <div className="dropdown-holder">
              <p className="dropdown-label">{translateText("language")}</p>
              <MultiSelect
                Initial={translateText("all_languages")}
                Options={props.AllLanguages}
                IsWithId
                Id={"language"}
                PreSelectedId=""
                ChangeHandler={() => addActiveFilter("language-clear")}
                OnReset={() => removeActiveFilter()}
              />
            </div>
          </section>
          {RangesAreDisplayed ? (
            <section className="range-filters">
              <DoubleRangeSlider
                MinValue={0}
                MaxValue={props.MaxLikes}
                Title={translateText("number_of_likes")}
                HandleChange={() => addRangeActiveFilter("Like")}
                Id="likes"
              />
              <DoubleRangeSlider
                MinValue={0}
                MaxValue={props.MaxBookmarks}
                Title={translateText("number_of_bookmarks")}
                HandleChange={() => addRangeActiveFilter("Bookmark")}
                Id="bookmarks"
              />
              <DoubleRangeSlider
                MinValue={0}
                MaxValue={props.MaxApps}
                Title={translateText("number_of_applications")}
                HandleChange={() => addRangeActiveFilter("App")}
                Id="apps"
              />
            </section>
          ) : null}
        </section>
      </main>
      <section className="filters-footer">
        <span onClick={() => apply()}>{translateText("apply_filters")}</span>
      </section>
    </div>
  );
};

export default MobileFilterMenu;
